// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f57c917e","453":"1f681d99","796":"c0cb5d11"}[chunkId] + ".chunk.js";
};